"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactScroll = require("react-scroll");

var _tableCompare = _interopRequireDefault(require("../../styles/table-compare.css"));

var shouldRenderLinks = function shouldRenderLinks(links, theme, names) {
  return links && links.map(function (link, i) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: _tableCompare["default"].navListItem,
      key: i
    }, /*#__PURE__*/_react["default"].createElement(_reactScroll.Link, {
      to: names[i],
      smooth: true,
      className: _tableCompare["default"].unselectedSection + " " + theme.tabInactive,
      activeClass: _tableCompare["default"].selectedSection + " " + theme.headingFive,
      offset: -70,
      spy: true
    }, link));
  });
};

var ComparisonNav = function ComparisonNav(_ref) {
  var links = _ref.links,
      theme = _ref.theme,
      names = _ref.names;
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: "" + _tableCompare["default"].navWrapper
  }, shouldRenderLinks(links, theme, names));
};

ComparisonNav.displayName = 'ComparisonNav';
ComparisonNav.defaultProps = {
  theme: {}
};
var _default = ComparisonNav;
exports["default"] = _default;